import { Mensagem, TipoMensagem } from '../../../models/mensagem';

export abstract class AtalhoConversa {

    public quantidadeMensagensNaoLidas: number;
    public textoUltimaMensagem: string;
    public dataUltimaMensagem: string;
    public horaUltimaMensagem: string;
    public apresentarIconeImagem: boolean;
    public apresentarIconeArquivo: boolean;

    protected abstract atualizarNumMensagensNaoLidas(): void
    
    protected abstract abrirConversa(): void

    protected hasMensagensNaoLidas(): boolean {
        return this.quantidadeMensagensNaoLidas > 0;
    }

    protected atualizarUltimaMensagem(mensagens: Mensagem[]): void {
        if (mensagens) {
            this.atualizarNumMensagensNaoLidas();
            const mensagem = mensagens[mensagens.length - 1];
            this.dataUltimaMensagem = mensagem.data;
            this.horaUltimaMensagem = mensagem.hora;
            this.apresentarIconeImagem = false;
            if (mensagem.tipo === TipoMensagem.HTML) {
                this.textoUltimaMensagem = mensagem.mensagemTexto;
            } else if (mensagem.tipo === TipoMensagem.IMAGEM) {
                this.textoUltimaMensagem = "Foto";
                this.apresentarIconeImagem = true;
            } else if (mensagem.tipo === TipoMensagem.ARQUIVO) {
                this.textoUltimaMensagem = "Arquivo";
                this.apresentarIconeArquivo = true;
            } else {
                this.textoUltimaMensagem = mensagem.mensagem;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/shared/abstract/atalho-conversa.ts